import {BaseRepository} from '../repositories/BaseRepository';
import {CacheService as Cache} from '../services/CacheService';
import {PaginationComponent as Pagination} from './PaginationComponent';
import {scrollToElement} from '../helpers/ActionHelper';

export class EventArchiveComponent {
  container = document.querySelector('body.post-type-archive-event');

  grid = null;

  form = null;

  formData = null;

  repository;

  pagination;

  cache;

  constructor() {
    if (!this.container) {
      return;
    }

    this.gridWrapper = this.container.querySelector('.js-post-grid-wrapper');
    if (!this.gridWrapper) {
      return;
    }

    this.grid = this.gridWrapper.querySelector('.js-post-grid');
    if (!this.grid) {
      return;
    }

    this.form = this.container.querySelector('form[name=filter]');
    if (!this.form) {
      return;
    }

    this.formData = new FormData(this.form);

    this.repository = new BaseRepository();

    if (this.gridWrapper) {
      this.pagination = new Pagination(this.formData.get('page'), this.formData.get('total_pages'), this.gridWrapper);
      this.pagination.appendPaginationElement();
    }

    this.cache = new Cache();

    this.addEventListeners();
  }

  addEventListeners() {
    this.form.addEventListener('submit', (e) => this.formSubmitHandler(e));

    const categories = this.container.querySelectorAll('.js-category-item');
    if (categories.length) {
      Array.from(categories).forEach((category) => {
        category.addEventListener('click', (e) => this.categoryClickHandler(e));
      });
    }

    document.addEventListener('click', (e) => {
      if (!e.target) {
        return;
      }

      const container = e.target.closest('.c-pagination');
      if (!container) {
        return;
      }

      if (e.target.tagName === 'A') {
        this.pageClickHandler(e);
      }
    });

    const modalOpenButton = document.querySelector('.js-open-subscribe-modal');
    if (modalOpenButton) {
      modalOpenButton.addEventListener('click', (e) => this.modalOpenButtonClickHandler(e));
    }
  }

  async formSubmitHandler(e) {
    e.preventDefault();

    if (e.submitter) {
      this.formData.set('page', 1);
    }

    this.cache.setKey(this.generateCacheKey());

    let response;
    if (this.cache.storage.has(this.cache.key)) {
      response = this.cache.storage.get(this.cache.key);
    } else {
      response = await this.repository.postWithFormData(this.formData);

      this.cache.storage.set(this.cache.key, response);
    }

    if (!response) {
      return;
    }

    this.formData.set('total_pages', response.data.total_pages);
    this.grid.innerHTML = response.data.grid_markup;

    this.pagination = new Pagination(this.formData.get('page'), this.formData.get('total_pages'), this.gridWrapper);
    this.pagination.appendPaginationElement();
    scrollToElement(this.grid);
  }

  categoryClickHandler(e) {
    const target = e.target;

    this.toggleActive(target);
    this.updateCategories(target);

    const filterSubmit = this.form.querySelector('input[name=filter_submit]');
    if (filterSubmit) {
      const submitEvent = new Event('submit');
      submitEvent.submitter = filterSubmit;
      this.form.dispatchEvent(submitEvent);
    }
  }

  toggleActive(element) {
    if (!element) {
      return;
    }

    if (element.classList.contains('active')) {
      return;
    }

    const parent = element.parentNode;
    if (!parent) {
      return;
    }

    const active = parent.querySelector('.active');
    if (active) {
      active.classList.remove('active');
    }

    element.classList.add('active');
  }

  updateCategories(element) {
    if (!element) {
      return;
    }

    const id = element.dataset.hasOwnProperty('id') ? parseInt(element.dataset.id) : 0;

    this.formData.set('category', id);
  }

  generateCacheKey() {
    let key = '';

    key += this.formData.has('page') ? this.formData.get('page') : '0';
    key += '__';
    key += this.formData.has('category') ? this.formData.get('category') : '0';

    return key;
  }

  pageClickHandler(e) {
    e.preventDefault();
    const target = e.target;

    const page = parseInt(target.innerHTML);
    this.formData.set('page', page);

    const submitEvent = new Event('submit');
    this.form.dispatchEvent(submitEvent);
  }

  async showModal() {
    const container = document.querySelector('.js-subscribe-modal-wrapper');
    if (!container) {
      return;
    }

    const form = container.querySelector('.hbspt-form');
    if (!form) {
      return;
    }

    const title = container.querySelector('.js-title');
    const description = container.querySelector('.js-description');

    let html = '';
    if (title) {
      html += title.outerHTML;
    }

    html += form.outerHTML;

    if (description) {
      html += description.outerHTML;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('subscribe-modal-wrapper');
    wrapper.innerHTML = html;

    try {
      const {Fancybox} = await import('@fancyapps/ui' /*webpackChunkName: "fancy" */);
      new Fancybox([
        {
          src: wrapper,
          type: 'html'
        }
      ]);
    } catch (error) {
      console.error('Error importing FancyBox:', error);
    }
  }

  modalOpenButtonClickHandler(e) {
    this.showModal();
  }
}